import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { AuthActions } from '../../../auth/auth.actions';
import { ProductUnlockActions } from './unlock.actions';

/**
 * @description Product Unlock Effects.
 * @exports
 * @class ProductUnlockEffects
 */
@Injectable()
export class ProductUnlockEffects {
  private readonly actions = inject(Actions);

  readonly onAuthLogout_SwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout, AuthActions.switchProfile),
        map(() => ProductUnlockActions.reset())
      );
    },
    { dispatch: true }
  );
}
